export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
export const API_BASE_URL = IS_PRODUCTION ? 'https://api.gostackr.com' : 'https://api-staging.gostackr.com';
export const API_KEY = IS_PRODUCTION ? 'CTZTocrkJ75AYbYlzdY3I6vAKpRkHmLz5lQDJTxb' : 'qgfmKDaElH5Tf1EgyiUbM1cnqJ2G9Sp11UVqVuoe';